import {lightTheme} from '@adobe/react-spectrum';
import './spectrum-overrides.css';

/**
 * Custom React Spectrum theme for the Trend application.
 *
 * IMPORTANT — How theming works in React Spectrum v3:
 *   React Spectrum's `theme` prop expects an object whose values are CSS-module
 *   class name references (not plain color objects). You CANNOT override colors
 *   by spreading `lightTheme` and adding color properties — that simply adds
 *   ignored properties to the object.
 *
 *   Instead, brand colors are applied via CSS custom-property overrides in
 *   `spectrum-overrides.css`.  The Provider must also receive the class name
 *   `trend-spectrum-theme` (via UNSAFE_className) so the CSS selectors match.
 *
 * Brand Palette (from default.theme.js):
 *   Primary light : #005795
 *   Primary main  : #1C408C
 *   Primary dark  : #1F2532
 *   Secondary     : #FF7043
 *   Success       : #4caf50
 *   Error         : #ff5252
 */
export const customSpectrumTheme = lightTheme;

/**
 * CSS class name that must be set on every React Spectrum <Provider>
 * via the UNSAFE_className prop so the color overrides in
 * spectrum-overrides.css take effect.
 *
 * Usage:
 *   <Provider theme={customSpectrumTheme} UNSAFE_className={SPECTRUM_THEME_CLASS} ...>
 */
export const SPECTRUM_THEME_CLASS = 'trend-spectrum-theme';

